import { Button, Text, VStack } from '@chakra-ui/react';
import svgIcons from '@/assets/svg/icons';

interface Props {
  status: string;
  isPending: boolean;
  isReinviting?: boolean;
  onReinvite?: () => void;
  onResolve?: () => void;
  reinviteBlockedReason?: string;
  revokeBlockedReason?: string;
  resolutionNote?: string;
}

const OrgMemberPendingReinvite = ({
  status,
  isPending,
  isReinviting = false,
  onReinvite,
  onResolve,
  reinviteBlockedReason,
  revokeBlockedReason,
  resolutionNote,
}: Props) => {
  const statusContent = (
    <>
      {status}
      {status === 'Pending' && (
        <svg width="13" height="14" viewBox="0 0 13 14" aria-hidden="true" style={{ marginLeft: 6, marginTop: 1 }}>
          <path d={svgIcons.reload} fill="currentColor" />
        </svg>
      )}
    </>
  );

  return (
    <VStack align="flex-start" spacing={1}>
      {onReinvite ? (
        <Button
          size="sm"
          variant="link"
          color="background.blueGray"
          fontWeight={600}
          onClick={onReinvite}
          isDisabled={isPending}
          isLoading={isReinviting}
          loadingText="Reinviting…"
          aria-label={isReinviting ? 'Reinviting invitation' : `Reinvite invitation (${status})`}
          _hover={{}}
          fontSize={16}
        >
          {statusContent}
        </Button>
      ) : (
        <Text color="background.blueGray" fontWeight={600}>
          {statusContent}
        </Text>
      )}
      {onResolve && (
        <Button size="xs" variant="link" onClick={onResolve} isDisabled={isPending}>
          Resolve
        </Button>
      )}
      {reinviteBlockedReason && (
        <Text fontSize="xs" color="text.mediumGray">
          Reinvite unavailable: {reinviteBlockedReason}
        </Text>
      )}
      {revokeBlockedReason && (
        <Text fontSize="xs" color="text.mediumGray">
          Revoke unavailable: {revokeBlockedReason}
        </Text>
      )}
      {resolutionNote && (
        <Text fontSize="xs" color="text.mediumGray">
          {resolutionNote}
        </Text>
      )}
    </VStack>
  );
};

export default OrgMemberPendingReinvite;
